import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INSERT_LINK_POPUP: `${cleanedFilename(__filename)}-insert-link-popup`,
};
